import { SimpleChipExpression } from "./common.data.types";

export abstract class ValueAdapter {
  abstract processValue(value);

  isChipExpressionBased(value: SimpleChipExpression[]): value is SimpleChipExpression[] {
    if ((typeof value) === 'string') {
      return false;
    }
    // empty array won't be recognized as array of ChipExpressions
    if (value as [] && !value.length) {
      return false;
    }
    const firstValue = value[0];
    if (firstValue as SimpleChipExpression && !(firstValue.keyword || firstValue.operator || firstValue.operands)) {
      return false;
    }
    return true;
  }
}
